export const Switch = ({ checked, onChange, labelledBy, describedBy, testId, disabled = false, busy = false }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-labelledby={labelledBy}
    aria-describedby={describedBy}
    data-testid={testId}
    disabled={disabled}
    aria-busy={busy || undefined}
    onClick={() => onChange(!checked)}
    className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[8px] disabled:cursor-not-allowed disabled:opacity-50"
  >
    <span
      aria-hidden="true"
      className={`relative block h-6 w-10 rounded-full border transition-colors duration-150 ${
        checked ? "border-ax-accent tint-chip-active" : "border-ax-muted bg-transparent"
      }`}
    >
      <span
        className={`absolute top-[3px] block h-4 w-4 rounded-full transition-transform duration-150 ${
          checked ? "translate-x-[18px] bg-ax-accent" : "translate-x-[3px] bg-ax-muted"
        }`}
      />
    </span>
  </button>
);
